import styled from 'styled-components'

export const FormulaModalWrapper = styled.div`
  // position: relative;
  height: 100%;
  font-size: 0.9rem;
  width: 800px;
  overflow-y: auto;
  overflow-x: hidden;
  // Hide scrollbar for Chrome, Safari, and newer Edge versions
  &::-webkit-scrollbar {
    display: none;
  }

  // Hide scrollbar for Firefox
  scrollbar-width: none;
`

export const FormulaModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
  margin: 0;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 250;

  h3 {
    font-size: 1.25rem;
    padding-left: 1.5rem;
    padding-top: 1.5rem;
  }
`
export const FormulaModalHero = styled.div`
  padding: 0.6rem 1.5rem 0.6rem 1.5rem;
  margin-bottom: 0;
  h5 {
    font-weight: 600;
    margin-bottom: 0.5rem;
    margin-top: 0;
  }
  small {
    color: #525e6d;
    font-size: 0.85rem;
  }
`

export const FormulaModalCloseIcon = styled.div`
  font-size: 2rem;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  border-radius: 0 10%;
  margin: 0;
  cursor: pointer;
`

export const FormulaModalBody = styled.div`
  padding: 0 1.5rem;
  min-height: 400px;
  // height: 56%;
  margin-bottom: 2rem;

  h5 {
    font-size: 0.85rem;
    padding: 0 0 0 0;
    margin: 1rem 0 0 0;
  }
  small {
    color: #525e6d;
    font-style: italic;
    font-size: 0.78rem;
  }
`

export const FormulaModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 16%;
  padding: 0 1.5rem 0 0;
  margin: 0;
  position: sticky;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  button {
    min-width: 8.5rem;
    white-space: nowrap;
  }
  gap: 1rem;
`

export const FormulaModalTabs = styled.div`
  display: flex;
  gap: 1.5rem;
  padding: 0 1.5rem;
  border-bottom: 1px solid #e5e5e5;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 250;
`

export const FormulaModalTab = styled.button<{ $isActive: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.6rem 0;
  font-size: 0.9rem;
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 400)};
  color: ${({ $isActive }) => ($isActive ? '#1a1a1a' : '#525e6d')};
  border-bottom: 2px solid
    ${({ $isActive }) => ($isActive ? '#0f7ee6' : 'transparent')};
`

export const FormulaTestResult = styled.div<{ $isError?: boolean }>`
  margin-top: 1.5rem;
  padding: 0.8rem 1rem;
  border-radius: 4px;
  word-break: break-word;
  background-color: ${({ $isError }) => ($isError ? '#fdf0f0' : '#f4f8fb')};
  border: 1px solid ${({ $isError }) => ($isError ? '#e6b0b0' : '#cddfee')};
  color: ${({ $isError }) => ($isError ? '#a02020' : '#1a1a1a')};

  h5 {
    margin: 0 0 0.3rem 0;
    font-size: 0.8rem;
    text-transform: uppercase;
    color: #525e6d;
  }
`
